<script>
/**
 * 首页数字条（15+ / 30+ / 2000+ / 98%）
 */
import NhCountUp from './NhCountUp.vue'
import { getSite } from '../nh-site-data'

export default {
  name: 'NhStatsStrip',
  components: { NhCountUp },
  computed: {
    STATS() {
      return getSite('STATS')
    }
  }
}
</script>

<template>
  <section class="stats">
    <div class="container">
      <div class="stats-grid">
        <div v-for="(stat, i) in STATS" :key="stat.label" v-reveal="i || undefined" class="stat">
          <b><NhCountUp :value="stat.value" :suffix="stat.suffix" /></b>
          <span>{{ stat.label }}</span>
        </div>
      </div>
    </div>
  </section>
</template>
